import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@manulife/mux';
import { urls } from 'constants';
import {
  DID_NOT_RECEIVED_CODE,
  NO_ACCESS_CONTACT_US,
} from 'application/enum/mfa.enum';
import { setStylesInfoPannel } from '../../styles/infoPannel.styles';

const RpsInfo = ({ type }) => {
  const theme = useTheme();
  const styles = setStylesInfoPannel(theme);
  const faqUrl = urls.REACT_APP_RPS_FAQ_URL;
  const contactUsUrl = urls.CONTACT_US_REDIRECT;
  const isMFAPage = type === 'mfa';
  const isEnterCode = type === 'enter-mfa-code';

  const onClickFaq = () => {
    window.open(faqUrl);
  };

  const onClickContactUs = () => {
    window.open(contactUsUrl);
  };

  const generateContactUsText = (mainText) => (
    <>
      {mainText} <span onClick={onClickContactUs}>contact us.</span>
    </>
  );

  const faqLink = (
    <>
      See <span onClick={onClickFaq}>frequently asked questions</span>.
    </>
  );

  const generateDescription = () => {
    if (isMFAPage) {
      return generateContactUsText(NO_ACCESS_CONTACT_US);
    } else if (isEnterCode) {
      return generateContactUsText(DID_NOT_RECEIVED_CODE);
    } else {
      return faqLink;
    }
  };

  return (
    <Box sx={styles.ctn}>
      <Typography sx={styles.needHelp}>Need help?</Typography>
      <Typography sx={styles.faq}>{generateDescription()}</Typography>
      <hr style={styles.hr} />
      <Typography sx={styles.note}>
        <strong>Note:</strong> Access and use of this site is for authorized
        users only.
      </Typography>
    </Box>
  );
};

export default RpsInfo;
